import React, { Component } from "react";

class Software extends Component {
  render() {
    return (
      <div>
        <div className="position-relative overflow-hidden text-center">
          <div className="col-md-6 mx-auto hero">
            <h1 className="p-3 font-weight-light">
              About
            </h1>
            <p className="leadfont-weight-normal">
                  I'm a software engineer from Brazil with 16 years of experience in a wide range of technologies. I like to work on new projects following good practices 
                 and using top-notch technologies. In my spare time, I often blog and take some photos, feel free to buy a frame in section Prints.
            </p>  
            <p className="leadfont-weight-normal">
                 Here I will share my experience, writing about a wide range of topics related to software development such as IoT, AI and machine learning, web, data and more. 
            </p>
            <p className="leadfont-weight-normal">
                For more professional information, feel free to visit:  
                <div className="socialbtns">
                  <ul>
                    <li><a href="https://www.linkedin.com/in/stefhan-campos-8357171a/" target="_blank" rel="noopener noreferrer"><img src={require('../static/img/linkedin-square-social-media.png')} className="rounded" alt="github logo with an link to my profile"/></a></li>             
                    <li><a href="https://github.com/stefhancampos" target="_blank" rel="noopener noreferrer"><img src={require('../static/img/github-square-social-media.png')} className="rounded" alt="github logo with an link to my profile"/></a></li>
                    <li><a href="mailto:stefhanrafael@gmail.com"><img src={require('../static/img/mail-square-social-media.png')} className="rounded" alt=".."/></a></li>
                  </ul>
                </div> 
            </p>    
          </div>
        </div>
      </div>
    )
  }
}

export default Software;



// WEBPACK FOOTER //
// ./src/components/Software.js